<div class="filter-item-container" fxLayout="column" fxLayoutAlign="start">
  <mat-checkbox [(ngModel)]="filterItem.isSelected" color="primary" (ngModelChange)="checkboxChanged()">
    <div>
      {{ filterItem.filter.displayName }}<span *ngIf="filterItem.group"> ({{ filterItem.group }})</span>
    </div>
  </mat-checkbox>
  <div class="filter-content" *ngIf="filterItem.isSelected" fxLayout="column">
    <div class="search-operator">
      <select [(ngModel)]="filterItem.filterOperator" (ngModelChange)="filterChanged()" aria-label="Select an operator">
        <option *ngFor="let op of operators" [ngValue]="op">{{ op.displayName }}</option>
      </select>
    </div>
    <div class="search-value" *ngIf="filterItem.filterOperator && filterItem.filterOperator.isSearchValueNeeded" fxFlex>
      <multiselect
        *ngIf="filterItem.uiType == uiType.Multiselect"
        [items]="multiselectItems"
        [selectedItems]="selectedMultiselectItems"
        (selectionChanged)="multiselectSelectionChanged($event)"
        [placeholder]="'Select items...'"
      >
      </multiselect>
      <mat-form-field
        appearance="outline"
        floatLabel="always"
        fxFlex
        class="dropdown-field"
        *ngIf="filterItem.uiType == uiType.DropDown"
      >
        <mat-select [(ngModel)]="filterItem.searchValue" (selectionChange)="filterChanged()">
          <mat-option *ngFor="let value of filterItem.filter.values" [value]="value" aria-label="Select a value">{{
            value
          }}</mat-option>
        </mat-select>
      </mat-form-field>
      <div class="inputs" *ngIf="filterItem.uiType == uiType.Textbox || filterItem.uiType == uiType.DatePicker">
        <mat-form-field *ngIf="filterItem.uiType == uiType.Textbox" appearance="outline" fxFlex>
          <input
            matInput
            [type]="inputType"
            [(ngModel)]="filterItem.searchValue"
            (change)="filterItem.searchValue = filterItem.searchValue.trim()"
            (blur)="filterChanged()"
            aria-label="Type a value"
          />
        </mat-form-field>
        <mat-form-field *ngIf="filterItem.uiType == uiType.DatePicker" appearance="outline" fxFlex>
          <input
            matInput
            [matDatepicker]="datePicker"
            [(ngModel)]="filterItem.searchValue"
            (ngModelChange)="filterChanged()"
            aria-label="Select a date"
          />
          <mat-datepicker-toggle matSuffix [for]="datePicker"> </mat-datepicker-toggle>
          <mat-datepicker #datePicker></mat-datepicker>
        </mat-form-field>
      </div>
    </div>
  </div>
</div>
